import { observer } from "mobx-react-lite"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import ChatUserItemComp from "../components/ChatUserItemComp"
import Loader from "../components/Loader"
import { ANONYMOUS } from "../models/constants"
import { rootStore } from "../StApp"
import ChatStore from "../stores/ChatStore"
import { chatStore } from "../stores/MainStore"



const ChatRefresh = observer(() => {
    return (<div className='flex-row center-both' style={{ position: 'absolute', right: 5 }} >
        REFRESH
        {chatStore.refreshProg == 'LOADING' ? <Loader absolute={false} /> : <span className="material-icons-outlined"

            onClick={() => chatStore.refreshChats()} >
            refresh
        </span>}
    </div>);
})


const ChatOverviewList = () => {


    useEffect(() => {

        chatStore.loadAllChats()

    }, [])

    switch (chatStore.loadProg) {

        case 'LOADING': return <Loader />

        case 'SUCCESS':
            if (chatStore.chatList.length < 1)
                return (
                    <div className='flex-column center-both' style={{ height: '70%' }} >
                        <p>You don't have any VNotes yet :/</p>
                        {rootStore.mainStore.userName != ANONYMOUS ?
                            <div>
                                <p>Share your link </p>
                                <p style={{ color: 'blue' }} >{window.location.hostname}/{rootStore.mainStore.userName}</p>
                                <p>to all your fans :)</p>
                            </div>
                            : <Link to='/stapp/register' className='button-place'>
                                <button className='button-5' >Register</button>
                            </Link>
                        }
                    </div>
                )
            else
                return (
                    <>
                        <div className='flex-row center-both relative' style={{ margin: 15 }} >
                            {rootStore.mainStore.userName == ANONYMOUS ?

                                <Link to='/stapp/register' className='button-place'>
                                    <button className='button-5' >Register</button>
                                </Link>

                                : null
                            }
                            <ChatRefresh></ChatRefresh>
                        </div>
                        <ul>
                            {
                                chatStore.chatList.map(item => (<ChatUserItemComp chatItem={item} key={item.chatId} />))
                            }
                        </ul>
                    </>
                )

        default: return <p>FAILED</p>
    }


}

export default observer(ChatOverviewList)